var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { IS_MAC } from "../../../../../lib/utils/consts";
let StyleNameHeader = class StyleNameHeader extends Vue {
  constructor() {
    super(...arguments);
    this.visible = false;
  }
  get title() {
    const h = this.$createElement;
    const nameTag = h("span", {
      "class": ['uc-style-header-name-label', this.changed ? 'changed' : '']
    }, [" ", this.name, " "]);
    if (this.$slots.tooltip) {
      return [h("span", [" ", nameTag, " "]), h("a-tooltip", {
        "attrs": {
          "placement": this.placement,
          "mouseEnterDelay": 0.3
        }
      }, [h("div", {
        "slot": "title"
      }, [" ", this.$slots.tooltip]), h("i", {
        "class": "fa fa-info-circle"
      })])];
    }
    return nameTag;
  }
  get titleWithReset() {
    const h = this.$createElement;
    if (this.changed) {
      return h("a-tooltip", {
        "attrs": {
          "placement": "topRight"
        }
      }, [h("div", {
        "slot": "title",
        "style": {
          display: 'flex',
          gap: '4px',
          alignItems: 'center'
        }
      }, [h("div", [" ", IS_MAC ? '⌥' : 'alt', " + click ", h("i", {
        "class": "fa fa-hand-pointer-o",
        "attrs": {
          "aria-hidden": "true"
        }
      }), "  "]), h("button", {
        "on": {
          "click": () => this.$emit('reset')
        },
        "class": "ucd-stylePanel-resetButton"
      }, [h("i", {
        "class": "fa fa-undo",
        "attrs": {
          "aria-hidden": "true"
        },
        "style": "margin-right: 4px"
      }), "\u91CD\u7F6E"])]), h("span", {
        "on": {
          "click": this.handleToggle
        }
      }, [" ", this.title, " "])]);
    }
    return this.title;
  }
  handleToggle(e) {
    if (this.changed && e.altKey) {
      this.$emit('reset');
      return;
    }
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": ['uc-style-header', {
        inline: this.inline
      }]
    }, [h("div", {
      "class": "uc-style-header-name"
    }, [" ", this.titleWithReset]), h("div", {
      "class": "content-slot"
    }, [this.$slots.default])]);
  }
};
__decorate([Prop({
  type: String,
  default: ''
})], StyleNameHeader.prototype, "name", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], StyleNameHeader.prototype, "changed", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], StyleNameHeader.prototype, "inline", void 0);
__decorate([Prop({
  type: String,
  default: 'right'
})], StyleNameHeader.prototype, "placement", void 0);
StyleNameHeader = __decorate([Component({
  name: 'StyleNameHeader'
})], StyleNameHeader);
export default StyleNameHeader;
//# sourceMappingURL=StyleConfTemplate.js.map
